import React, { useState, useEffect } from "react";
import Tree from "../../Tree/Tree";
import "./TreeBox.css";
import "../Styles/SvgCommand.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function TreeBox(props) {
  const [isDragOver, setDragover] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const onDropDownItemClick = (itemSelected) => {};
  const buildStyle = useBuildStyle();
  const shiftPosition = 1;
  useEffect(() => {
     props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getContainerStyle = () => {
    var newStyle = buildStyle(props.style);
    newStyle["position"] = "absolute";
   
    newStyle["border"] = isDragOver ? "1px dashed #1f79e1" : props.style.border.value;
    return newStyle;
  };
  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };
  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };

  const getStyle = () => {
    
    var newStyle = {};

    newStyle["width"] = parseInt(props.style.width.value.slice(0,-2)) - 15 + "px" ;
    newStyle["height"] = parseInt(props.style.height.value.slice(0,-2)) - 10 + "px" ;
   
    newStyle["position"] = "absolute";
    
    return newStyle;
  };

  const buildTreeData = (nodes, treeData) => {
    nodes.map(node => {
      treeData.push({id:"" + node.id + "", item:node.value.value, isExpanded:false, isChecked:false, childs:[]})
      buildTreeData(node.childs, treeData.filter(item => item.id == node.id)[0].childs)
    })
  }

  const getCurrentMenuData = () => {
    
    let option = props.data.properties.data.option //props.data.option && props.data.option.filter(item => item.type == "properties" && item.menu == "data")[0]
    let current = props.data.properties.data.value
    var treeData = []
    if (option && current[option.toLowerCase()].values) {
      buildTreeData(current[option.toLowerCase()].values
      .filter(item => item.id == current[option.toLowerCase()].id)[0].details, treeData)
    }
    
    
    return treeData
  
  };
  
  return (
      <div
        onClick={props.onClick} 
        style={getContainerStyle()}
        id={props.data.id}>
    
        <div 
          draggable={props.draggable}
          onDragStart={(e) => props.onDragStart(e)}
          onDrop={(e) => props.onlyLabel && onDropColumn(e)}
          onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
          onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
          onClick={props.onClick} 
          style={getStyle()}>
            <Tree 
              withCheckBox = {props.data.properties.checkBox.value} 
              menuItems = {getCurrentMenuData()}
              onCheckedItem = {(checkeds, dataLabel, menuPaths) =>  props.onChange(undefined, {checkeds:checkeds, dataLabel:dataLabel, menuPaths:menuPaths})}
              onUnCheckedItem = {(checkeds, dataLabel, menuPaths) =>  props.onChange(undefined, {checkeds:checkeds, dataLabel:dataLabel, menuPaths:menuPaths})}/>
        </div>
      </div>
   
  );
}
